import { useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { collabTemplateData } from "./collabTemplateData"; // import your data

const CollabTemplates = () => {
  const [templates, setTemplates] = useState(collabTemplateData);
  const navigate = useNavigate();
  const createNewCollab = async (template) => {
    try {
      let documents = [];

      if (template.file) {
        const response = await fetch(`/templates/${template.file}`);
        const blob = await response.blob();

        const file = new File([blob], template.file, {
          type: blob.type,
        });

        documents = [
          {
            documentName: template.file,
            description: template.description || "",
            file: file,
            fileType: blob.type,
          },
        ];
      }

      navigate("/dashboard/my-collabs/new-collab", {
        state: {
          collaborationName: template.name,
          checklist: template.checklist,
          documents: documents,
        },
      });
    } catch (err) {
      console.error("Failed to fetch template file:", err);
    }
  };

  return (
    <div style={{ overflowX: "auto", width: "100%" }}>
      <Table
        striped
        bordered
        hover
        responsive
        style={{ minWidth: "1100px", whiteSpace: "nowrap" }}
      >
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Description</th>
            <th>Checklist</th>
            <th>File</th>
            <th>Type</th>
            <th>Created By</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {templates.map((template) => (
            <tr key={template.id}>
              <td>{template.id}</td>
              <td>{template.name}</td>
              <td>{template.description}</td>
              <td>{template.checklist.join(", ")}</td>
              <td>
                {template.file ? (
                  <a
                    href={`/templates/${template.file}`} // use the file name directly
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {template.file}
                  </a>
                ) : (
                  "None"
                )}
              </td>

              <td>{template.type}</td>
              <td>{template.createdBy}</td>
              <td>
                <Button
                  variant="success"
                  size="sm"
                  onClick={() => createNewCollab(template)}
                >
                  Create
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default CollabTemplates;
